export enum MEASURE {
  EMPTY_STATE = "empty_state_time",
  SUGGEST = "suggest_time",
  SUGGEST_RENDER = "suggest_render_time",
  SEARCH_FIELD_INIT = "initial_search_box_time"
}
